@if (eventForm$ && this.selectedEventType!.code !== 'appointment') {
  <section>
    <app-dynamic-form
      [form]="eventForm$ | async"
      [disabled]="formDisabled"
      [showButtons]="editableEvent"
      [showSaveAndRouteButton]="editableEvent"
      [disableSaveAndRoute]="!selectedCustomer"
      [skipDeleteDialog]="true"
      [saveAndRouteButtonTitle]="saveAndRouteButtonTitle"
      (submitForm)="saveEvent($event)"
      (saveAndRoute)="saveEvent($event, 'customer')"
      (cancelButtonClick)="doCancel()"
      (selectedUser)="handleUser($event)"
      (delete)="doDelete()"
    ></app-dynamic-form>
  </section>
}

<section
  [hidden]="!eventData || this.selectedEventType?.code !== 'appointment'"
>
  <div class="compact-panel">
    <form [formGroup]="eventForm" (ngSubmit)="onSaveButtonClick()">
      <div class="grid event-form-grid">
        <section class="col-12 center-content mt-0 mb-4">
          <ng-container>
            @if (!formDisabled) {
              <div class="mr-2">
                <button
                  pButton
                  [type]="'submit'"
                  [className]="saveButton.styleClass!"
                  [disabled]="saveDisabled"
                  data-cy="event-save-btn"
                >
                  {{ saveButton.title }}
                </button>
              </div>
            }
            @if (!formDisabled || (formDisabled && selectedCustomer)) {
              <div class="mr-2">
                <button
                  pButton
                  [type]="'button'"
                  [className]="saveAndRouteButton.styleClass || ''"
                  [title]="saveAndRouteButton.title"
                  [disabled]="saveDisabled"
                  (click)="onSaveButtonClick('customer')"
                >
                  {{ saveAndRouteButton.title }}
                </button>
              </div>
            }
            @if (!formDisabled || (formDisabled && selectedCustomer)) {
              <div class="mr-2">
                <button
                  pButton
                  [type]="'button'"
                  [className]="goToFormsButton.styleClass || ''"
                  [title]="goToFormsButton.title"
                  [disabled]="saveDisabled"
                  (click)="onSaveButtonClick('forms')"
                >
                  {{ goToFormsButton.title }}
                </button>
              </div>
            }
            @if (!formDisabled || (formDisabled && selectedCustomer)) {
              <div class="mr-2">
                <button
                  pButton
                  [type]="'button'"
                  [className]="healthRecordButton.styleClass || ''"
                  [title]="healthRecordButton.title"
                  (click)="onSaveButtonClick('healthrecord')"
                >
                  {{ healthRecordButton.title }}
                </button>
              </div>
            }
            <!----
                  <div
                    class="mr-2"
              *ngIf="
                eraVisitEntriesEnabled &&
                (!formDisabled || (formDisabled && selectedCustomer))
              "
                    >
                    <p-button
                      [type]="'button'"
                      [className]="eraButton.styleClass || ''"
                      [title]="eraButton.title"
                      (click)="onSaveButtonClick('era')"
                      >{{ eraButton.title }}</p-button
                      >
                    </div>
                    -->
            @if (!formDisabled) {
              <div>
                <button
                  pButton
                  [type]="'button'"
                  [className]="cancelButton.styleClass || ''"
                  [title]="cancelButton.title"
                  (click)="doCancel()"
                >
                  {{ cancelButton.title }}
                </button>
              </div>
            }
            <!-- Käyntitodistus (AL-2893): the button prints in the
                 organization unit's language, the chevron offers the
                 other languages. -->
            <div class="mr-2 print-button-group">
              <button
                pButton
                [type]="'button'"
                icon="pi pi-print"
                [className]="'p-button-outlined'"
                [title]="'common.print' | translate"
                [disabled]="printing"
                (click)="printVisitCertificate()"
              ></button>
              <button
                pButton
                [type]="'button'"
                icon="pi pi-chevron-down"
                [className]="'p-button-outlined print-language-toggle'"
                [title]="
                  'event.visit-certificate-print.language-title' | translate
                "
                [disabled]="printing"
                (click)="openPrintLanguageMenu($event, printLanguagePopover)"
              ></button>
              <p-popover #printLanguagePopover>
                <div class="print-language-menu">
                  <span class="print-language-title">
                    {{
                      'event.visit-certificate-print.language-title' | translate
                    }}
                  </span>
                  @for (
                    printLanguage of printLanguages;
                    track printLanguage.code
                  ) {
                    <button
                      type="button"
                      class="print-language-option"
                      [disabled]="printing"
                      (click)="
                        printLanguagePopover.hide();
                        printVisitCertificate(printLanguage.code)
                      "
                    >
                      <span>{{ printLanguage.label }}</span>
                      @if (printLanguage.code === defaultPrintLanguage) {
                        <span class="pi pi-check print-language-default"></span>
                      }
                    </button>
                  }
                </div>
              </p-popover>
            </div>
          </ng-container>
        </section>

        <div class="md:col-6 sm:col-12">
          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label for="date">{{ 'event.date' | translate }}</label>
            </div>
            <div class="col-6 lg:col-4 grid">
              <app-datepicker-input
                [value]="selectedDate"
                [disabled]="formDisabled"
                (dateChange)="handleSelectedDate($event)"
              ></app-datepicker-input>
            </div>
          </div>
          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label for="start">{{ 'event.time' | translate }}</label>
            </div>
            <div class="col-6 pl-0 flex align-items-center gap-2">
              <p-inputMask
                [formControlName]="'start'"
                id="start"
                [type]="'99:99'"
                [mask]="'99:99'"
                characterPattern="[A-Za-z-+]"
                styleClass="e2e-event-time-start time-input-mask"
              ></p-inputMask>
              <span>-</span>
              <p-inputMask
                [formControlName]="'end'"
                id="end"
                [type]="'99:99'"
                [mask]="'99:99'"
                characterPattern="[A-Za-z-+]"
                styleClass="e2e-event-time-end time-input-mask"
              ></p-inputMask>
            </div>
          </div>
          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label for="customer">{{ 'event.customer' | translate }}</label>
            </div>
            <div class="col-6 pl-0">
              <app-customer-selector
                id="customer"
                [defaultUser]="selectedCustomer ? [selectedCustomer] : []"
                [userType]="userTypeCustomer"
                [fieldName]="'customer'"
                [customerType]="'cd'"
                [disabled]="formDisabled"
                [hideTabs]="true"
                (selectedUser)="handleSelectedUser($event, userTypeCustomer)"
                (userCleared)="handleSelectedUser(null, userTypeCustomer)"
              ></app-customer-selector>
            </div>
          </div>

          <div [hidden]="!showInlineScForm" class="sc-inline-panel">
            <h6 class="sc-inline-panel__title">
              {{ 'user.add-customer' | translate }}
            </h6>
            <app-sc-basic-info
              [customer]="inlineScCustomer"
              (customerSaved)="onInlineCustomerSaved($event)"
            ></app-sc-basic-info>
          </div>

          @if (!showInlineScForm) {
            <div class="field grid">
              <div class="col-6 lg:col-4">
                <label for="partner">{{ 'common.partner' | translate }}</label>
              </div>
              @if (partner) {
                <p id="partner">
                  {{ partner.firstName }} {{ partner.lastName }}
                </p>
              }
            </div>
          }

          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label for="description">{{
                'event.description' | translate
              }}</label>
            </div>
            <div class="col-6 pl-0">
              <p-select
                id="description"
                [options]="eventPackages"
                [optionLabel]="'name'"
                [optionValue]="'id'"
                [formControlName]="'productPackageId'"
                [showClear]="true"
                class="w-100"
                appendTo="body"
                styleClass="e2e-event-description"
              ></p-select>
            </div>
          </div>
          @if (isOpuPackageSelected) {
            <div class="field grid">
              <div class="col-6 lg:col-4">
                <label>{{ 'event.trigger-duration' | translate }}</label>
              </div>
              <div class="col-6 lg:col-8 trigger-duration-row pl-0">
                <div class="trigger-duration-select">
                  <p-select
                    [options]="triggerDurationOptions"
                    [optionLabel]="'description'"
                    [optionValue]="'code'"
                    [(ngModel)]="selectedTriggerDuration"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="onTriggerDurationChange($event.value)"
                    (onClear)="onTriggerDurationChange(null)"
                    [showClear]="true"
                    appendTo="body"
                    class="w-100"
                  ></p-select>
                </div>
                @if (triggerTimeBasedOnOpu) {
                  <div class="trigger-duration-computed">
                    <span class="trigger-time-label">
                      {{ 'event.trigger-time-computed' | translate }}:
                      {{ triggerTimeBasedOnOpu | appDate: 'dd.MM. HH:mm' }}
                    </span>
                  </div>
                }
              </div>
            </div>
          }
          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label>{{ 'common.status' | translate }}</label>
            </div>
            <div class="col-6 lg:col-4 grid">
              @for (option of eventStatusSettings; track option) {
                <div class="fullWidth">
                  <p-radioButton
                    #{{option.code}}
                    [id]="option.code"
                    [name]="'status'"
                    [value]="option.code"
                    [formControlName]="'status'"
                    (click)="handleRadioGroup('status', option.code)"
                  ></p-radioButton>
                  <label [for]="option.code" class="ml-2">{{
                    option.description
                  }}</label>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="md:col-6 sm:col-12">
          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label for="staff">{{ 'event.staff' | translate }}</label>
            </div>
            <div class="col-6 lg:col-4 grid">
              <app-user-selector
                id="staff"
                [defaultUser]="selectedUser ? [selectedUser] : []"
                [userType]="userTypeStaff"
                [fieldName]="'user'"
                [disabled]="formDisabled"
                (selectedUser)="handleSelectedUser($event, userTypeStaff)"
                (userCleared)="handleSelectedUser($event, userTypeStaff)"
              ></app-user-selector>
            </div>
          </div>
          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label for="room">{{ 'event.room' | translate }}</label>
            </div>
            <div class="col-6 pl-0">
              <p-select
                id="room"
                [options]="rooms"
                [optionLabel]="'description'"
                [optionValue]="'code'"
                [formControlName]="'room'"
                [showClear]="true"
                class="w-100"
                appendTo="body"
                (onChange)="disableSaveButton()"
                (onClear)="disableSaveButton()"
              ></p-select>
            </div>
          </div>
          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label for="group">{{ 'common.group' | translate }}</label>
            </div>
            <div class="col-6 lg:col-4 pl-0">
              <p-multiSelect
                id="group"
                [options]="eventRoles"
                [optionLabel]="'translation'"
                [optionValue]="'name'"
                [formControlName]="'userGroups'"
                [showClear]="true"
                [display]="'chip'"
                [filter]="false"
                [maxSelectedLabels]="99"
                styleClass="group-multiselect"
                class="w-100"
                appendTo="body"
                (onClear)="disableSaveButton()"
                (onChange)="disableSaveButton()"
              ></p-multiSelect>
            </div>
          </div>
          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label for="info">{{ 'event.info' | translate }}</label>
            </div>
            <div class="col-6 lg:col-4 grid">
              <textarea
                pInputTextarea
                id="info"
                [rows]="4"
                [cols]="30"
                [formControlName]="'info'"
              ></textarea>
            </div>
          </div>

          <h6>
            {{ 'event.appointment-schedule' | translate }}
          </h6>

          <div class="field grid">
            <div class="col-6 lg:col-4">
              <label>{{ 'event.net' | translate }}</label>
            </div>
            <div class="col-6 lg:col-4 grid">
              @for (option of yesNoSettings; track option) {
                <div class="fullWidth">
                  <p-radioButton
                    #{{option.code}}
                    [id]="option.code"
                    [name]="'net'"
                    [value]="option.code"
                    [formControlName]="'net'"
                    (click)="handleRadioGroup('net', option.code)"
                  ></p-radioButton>
                  <label [for]="option.code" class="ml-2">{{
                    option.description
                  }}</label>
                </div>
              }
            </div>
          </div>
          <div [hidden]="!net">
            <div class="field grid">
              <div class="col-6 lg:col-4">
                <label for="productPackageUserType">{{
                  'event.professional-group' | translate
                }}</label>
              </div>
              <div class="col-6 lg:col-4 grid">
                <p-select
                  id="productPackageUserType"
                  [options]="packageUserTypes"
                  [optionLabel]="'description'"
                  [optionValue]="'code'"
                  [formControlName]="'productPackageUserType'"
                  [showClear]="true"
                  appendTo="body"
                ></p-select>
              </div>
            </div>

            @if (eventData?.appointmentCustomer) {
              <h6>
                {{ 'event.appointment-customer-data' | translate }}
              </h6>
              <div class="field grid my-0">
                <div class="col-6 lg:col-4">
                  <label for="appointmentCustomer">{{
                    'common.name' | translate
                  }}</label>
                </div>
                <div class="col-6 lg:col-4">
                  <p>
                    {{ eventData!.appointmentCustomer!.firstName }}
                    {{ eventData!.appointmentCustomer!.lastName }}
                  </p>
                </div>
              </div>
              <div class="field grid my-0">
                <div class="col-6 lg:col-4">
                  <label for="appointmentEmail">{{
                    'common.email' | translate
                  }}</label>
                </div>
                <div class="col-6 lg:col-4">
                  <p>{{ eventData!.appointmentCustomer!.email }}</p>
                </div>
              </div>
              @if (eventData!.appointmentCustomer!.phoneNumber) {
                <div class="field grid my-0">
                  <div class="col-6 lg:col-4">
                    <label for="appointmentPhone">{{
                      'contact.phone' | translate
                    }}</label>
                  </div>
                  <div class="col-6 lg:col-4">
                    <p>
                      {{ eventData!.appointmentCustomer!.phoneNumber }}
                    </p>
                  </div>
                </div>
              }
              @if (eventData!.appointmentCustomer!.description) {
                <div class="field grid">
                  <div class="col-6 lg:col-4">
                    <label for="appointmentDescription">{{
                      'event.customer-description' | translate
                    }}</label>
                  </div>
                  <div class="col-6 lg:col-4">
                    <p>{{ eventData!.appointmentCustomer!.description }}</p>
                  </div>
                </div>
              }

              @if (eventData?.organizationForm?.values) {
                @for (
                  value of eventData.organizationForm.values | keyvalue;
                  track value.key
                ) {
                  @if (value.value) {
                    <div class="field grid">
                      <div class="col-6 lg:col-4">
                        <label for="appointmentDescription">{{
                          'organization-forms.' + value.key.toString()
                            | translate
                        }}</label>
                      </div>
                      <div class="col-6 lg:col-4">
                        @if (isDate(value.value)) {
                          <p>{{ value.value | appDate: 'dd.MM.yyyy' }}</p>
                        } @else {
                          <p>{{ value.value }}</p>
                        }
                      </div>
                    </div>
                  }
                }
              }
            }
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
